<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Lieferschein - {{ deliveryReceiptData.purchase.invoice_number }}
          </v-card-title>
          <v-card-text>
            <v-spacer />
            <v-divider class="mb-3" />
            <v-text-field v-model="deliveryReceiptNumber" outlined required label="Lieferschein Nummer" />
            <div v-for="(item, key) in deliveryReceipt" :key="key">
              <v-spacer :key="key" />
              <v-card class="my-3">
                <v-card-title>
                  {{ item.name }}
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6" lg="4">
                      <h4>Soll Menge: {{ item.amount }}</h4>
                      <v-text-field :value="getAmount[key]" readonly label="Liefer Menge" />
                    </v-col>
                    <v-col class="mt-3" cols="12" md="6" lg="8">
                      <v-combobox
                        v-model="item.serialCodes"
                        label="Serienummern"
                        multiple
                        chips
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
            <div class="d-flex justify-end">
              <v-btn color="primary" class="mt-3" @click="update()">
                SPEICHERN
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
export default {
   name: 'IncomingIndex',
   metaInfo () {
      return {
         title: this.title ? this.title : 'Lieferschein Bestellung - ' + this.deliveryReceiptData.purchase.invoice_number,
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      purchaseItemData: {
         type: Object,
         required: true
      },
      deliveryReceiptData: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         deliveryReceipt: [],
         deliveryReceiptNumber: this.deliveryReceiptData.delivery_receipt_number
      }
   },
   computed: {
      getAmount: function () {
         const amount = []
         this.deliveryReceipt.forEach((item, i) => {
            amount[i] = item.serialCodes.length
         })
         return amount
      }
   },
   mounted () {
      this.createDeliveryReceipt()
   },
   methods: {
      createDeliveryReceipt () {
         for (const [key, item] of Object.entries(this.purchaseItemData)) {
            this.deliveryReceipt.push(
               {
                  name: item.name,
                  amount: item.amount,
                  purchase_item_data_id: key,
                  serialCodes: item.serialCodes
               }
            )
         }
      },
      update () {
         if (this.deliveryReceiptNumber !== null && this.deliveryReceiptNumber !== '') {
            this.$inertia.patch(this.route('delivery_receipt.update', this.deliveryReceiptData.id), this.deliveryReceipt)
         }
      }
   }
}
</script>

<style>

</style>
